import script from "./ui_confirm_3.vue?vue&type=script&setup=true&lang=js"
export * from "./ui_confirm_3.vue?vue&type=script&setup=true&lang=js"

import "./ui_confirm_3.vue?vue&type=style&index=0&id=2c14d08e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dev-website\\战游\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c14d08e"]])

export default __exports__